import List from "components/list";
import { useParams } from "react-router-dom";
import { DateCell } from "@/components/date/cell";
import { EmployeeUserCell } from "components/cell/employee/cell";
import { getdirectusUserFields } from "components/user/config";
import { LinkCell } from "@/components/link/cell";
import { assetUrl } from "utils";
import CreateItemButton from "components/buttons/create";
import HeaderPortal from "components/portal/header-portal";
import { PermissionControlledInput } from "permissions/components/input";

export default function ClientTestimonials() {
  const { clientId } = useParams();
  const columns = [
    {
      id: "feedback",
      header: "Feedback",
      accessorKey: "feedback",
      cell: ({ getValue }) => (
        <div className="max-w-md truncate">{getValue()}</div>
      ),
    },
    {
      id: "video",
      header: "Video",
      accessorKey: "video",
      cell: ({ getValue }) => (
        <LinkCell getValue={() => assetUrl(getValue())} />
      ),
    },
    {
      id: "review_url",
      header: "Review",
      accessorKey: "review_url",
      cell: LinkCell,
    },
    {
      id: "date_created",
      header: "Created on",
      accessorKey: "date_created",
      cell: DateCell,
    },
    {
      id: "user_created",
      header: "Created by",
      accessorKey: "user_created",
      cell: EmployeeUserCell,
    },
  ];
  const fields = [
    "id",
    "feedback",
    "video",
    "review_url",
    "date_created",
    getdirectusUserFields("user_created"),
  ];
  const filters = {
    client: { _eq: clientId },
  };
  return (
    <div className="flex-1 w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule="create:*"
          collection="testimonials"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Testimonial</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <List
        href={(item) => `/crm/clients/${clientId}/testimonials/${item.id}`}
        title="Testimonials"
        endPoint="testimonials"
        storageKey={`testimonials-${clientId}`}
        showSearch={false}
        filters={filters}
        columns={columns}
        meta={{ fields }}
      />
    </div>
  );
}
